var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.1667V13.4167C7.58579 13.4167 7.25 13.7525 7.25 14.1667H8ZM13 14.1667H13.75C13.75 13.7525 13.4142 13.4167 13 13.4167V14.1667ZM8 14.9167H13V13.4167H8V14.9167ZM12.25 14.1667V15.0001H13.75V14.1667H12.25ZM8.75 15.0001V14.1667H7.25V15.0001H8.75ZM10.5 16.7501C9.5335 16.7501 8.75 15.9666 8.75 15.0001H7.25C7.25 16.795 8.70507 18.2501 10.5 18.2501V16.7501ZM12.25 15.0001C12.25 15.9666 11.4665 16.7501 10.5 16.7501V18.2501C12.2949 18.2501 13.75 16.795 13.75 15.0001H12.25Z",
    fill: "#FF5B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 5.00008C17.9999 6.84103 16.5075 8.33341 14.6666 8.33341C12.8256 8.33341 11.3333 6.84103 11.3333 5.00008C11.3333 3.15913 12.8256 1.66675 14.6666 1.66675C16.5075 1.66675 17.9999 3.15913 17.9999 5.00008Z",
    stroke: "#FF5B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2056 2.75333C11.6661 2.58861 11.0934 2.5 10.4999 2.5C7.27825 2.5 4.66659 5.11168 4.66659 8.33332V11.4353C4.66659 11.5835 4.60775 11.7255 4.50302 11.8302L4.07733 12.2559C3.92105 12.4122 3.83325 12.6241 3.83325 12.8451V13.3333C3.83325 13.7936 4.20635 14.1666 4.66659 14.1666H16.3333C16.7935 14.1666 17.1666 13.7936 17.1666 13.3333V12.8451C17.1666 12.6241 17.0788 12.4122 16.9225 12.2559L16.4968 11.8302C16.3921 11.7255 16.3333 11.5835 16.3333 11.4353V8.33332C16.3333 8.18628 16.3278 8.04052 16.3168 7.89681",
    stroke: "#FF5B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.ea0db6959ac3a5264b74b5a2889c92aa.svg";
export { ForwardRef as ReactComponent };